import {spawnNewWindow} from '@netx/core-next/utils/browser';
import {BrandPortalActionType, type IBrandPortalAction} from '../schema';
import {routeToPortalPageFromPortalAction} from './routeToPortalPageFromPortalAction';
import {appRouter} from '@netx/core-next/instance';

export const performCustomPortalAction = (action: IBrandPortalAction) => {
	switch (action.goo.type) {
		case BrandPortalActionType.PAGE:
			routeToPortalPageFromPortalAction(action);
			break;
		case BrandPortalActionType.URL:
			spawnNewWindow(action.goo.link);
			break;
		case BrandPortalActionType.ASSET:
		case BrandPortalActionType.CATEGORY:
			appRouter.navigate(action.goo.link.replace(/^#/, ''), true);
			break;
	}
};
